/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { StampType } from '@pelando/components';

export type StampsProps = {
  discountPercentage: boolean;
  discountFixed: boolean;
  freeShipping?: boolean | null;
  price: boolean;
};

export const getStampByType = (stamps: StampsProps) => {
  if (stamps.discountFixed) {
    return StampType.DISCOUNT_FIXED;
  }
  if (stamps.discountPercentage) {
    return StampType.DISCOUNT_PERCENTAGE;
  }
  if (stamps.price) {
    return StampType.PRICE;
  }
  if (stamps.freeShipping) {
    return StampType.FREE_SHIPPING;
  }
  return StampType.FREE;
};
